import { FunctionComponent } from 'react';

interface ModalTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  center?: boolean;
  subtitleClass?: string;
}

const ModalTitle: FunctionComponent<ModalTitleProps> = ({
  title,
  subtitle,
  subtitleClass,
  center = true,
  ...rest
}: ModalTitleProps) => {
  return (
    <div className={`${center ? 'text-center' : null} ${rest.className}`}>
      <h2 className="mb-4 font-bold text-2xl">{title}</h2>
      {subtitle && (
        <p className={`mb-6 ${subtitleClass ? subtitleClass : 'w-4/5 m-auto'} font-medium text-gray-400`}>{subtitle}</p>
      )}
    </div>
  );
};

export default ModalTitle;
